const bundles = {
  // قسم المتجر (يظهر داخل متجر الإضافات)
  sectionTitle: 'الباقات',
  sectionSubtitle: 'وفّر أكثر بشراء الإضافات معاً',
  // ترويسة صفحة /bundles المخصّصة
  pageTitle: 'الباقات',
  pageSubtitle: 'وفّر أكثر بشراء الإضافات معاً ضمن باقة',
  planDiscountNote: 'باقتك: خصم {{percent}}% على كل الباقات',
  empty: 'لا توجد باقات متاحة حالياً.',
  loadError: 'تعذّر تحميل الباقات',
  whatsInside: 'ما الذي تتضمنه',
  itemLine: '{{name}} ×{{count}}',
  youSave: 'توفّر {{amount}} ريال',
  signInToBuy: 'سجّل الدخول لشراء الباقات',

  // الفئات المستهدفة
  audience: {
    OWNER: 'المالك',
    BROKER: 'الوسيط',
    COMPANY: 'الشركة',
    ALL: 'الجميع',
  },

  // أنواع الخصم
  discountKind: {
    NONE: 'بدون خصم',
    PERCENTAGE: 'نسبة مئوية',
    FIXED_SAR: 'مبلغ ثابت (ريال)',
    COINS: 'نقاط',
  },

  // التسعير
  priceSar: '{{price}} ريال',
  coinPrice: '{{count}} نقطة',
  free: 'مجاني',
  yourBalance: 'رصيدك',

  // الأزرار
  buy: 'شراء الباقة',
  payWithCoins: 'الدفع بالنقاط',
  cancel: 'إلغاء',

  // التنبيهات
  purchaseSuccess: 'تم شراء الباقة وتفعيلها بنجاح',
  payWithCoinsSuccess: 'تم تفعيل الباقة وخصم النقاط من رصيدك.',
  insufficientCoins: 'رصيد النقاط غير كافٍ. يرجى شحن رصيدك والمحاولة مرة أخرى.',
  actionError: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',

  // لوحة الإدارة: منشئ الباقات / الإدارة
  admin: {
    title: 'الباقات',
    subtitle: 'إنشاء وإدارة باقات الإضافات',
    addBundle: 'إضافة باقة',
    editBundle: 'تعديل الباقة',
    createBundle: 'إنشاء باقة',
    empty: 'لا توجد باقات بعد. أنشئ واحدة للبدء.',
    deleteConfirm:
      'هل أنت متأكد من حذف "{{name}}"؟ إذا كانت عليها عمليات شراء فسيتم تعطيلها بدلاً من حذفها.',

    // أعمدة الجدول
    colName: 'الاسم',
    colItems: 'العناصر',
    colDiscount: 'الخصم',
    colAudiences: 'الفئات',
    colPrice: 'السعر',
    colStatus: 'الحالة',
    colActions: 'الإجراءات',
    colActive: 'نشط',
    colInactive: 'غير نشط',
    itemsCount_zero: 'بدون عناصر',
    itemsCount_one: 'عنصر واحد',
    itemsCount_two: 'عنصران',
    itemsCount_few: '{{count}} عناصر',
    itemsCount_many: '{{count}} عنصراً',
    itemsCount_other: '{{count}} عنصر',

    // عناوين الحقول
    fieldSlug: 'المعرّف (Slug)',
    fieldSlugHint: 'أحرف إنجليزية صغيرة وأرقام وشرطات سفلية. لا يمكن تغييره لاحقاً.',
    fieldName: 'الاسم (إنجليزي)',
    fieldNameAr: 'الاسم (عربي)',
    fieldDescription: 'الوصف (إنجليزي)',
    fieldDescriptionAr: 'الوصف (عربي)',
    fieldAudiences: 'الفئات المستهدفة',
    fieldItems: 'الإضافات ضمن هذه الباقة',
    fieldItemsHint: 'لا يمكن إضافة الإضافات المعتمدة على عرض السعر، ولذلك لا تظهر هنا.',
    fieldDiscount: 'الخصم',
    fieldDiscountValue: 'قيمة الخصم',
    fieldDiscountValueHintPercentage: 'نسبة الخصم من السعر الأساسي (0-100).',
    fieldDiscountValueHintFixed: 'مبلغ ثابت بالريال يُخصم من السعر الأساسي.',
    fieldDiscountValueHintCoins: 'عدد النقاط التي تُحوّل إلى خصم بالريال حسب السعر الحالي.',
    fieldActive: 'نشط (ظاهر في المتجر)',
    fieldSortOrder: 'ترتيب العرض',
    addItem: 'إضافة',
    quantity: 'الكمية',
    remove: 'إزالة',

    // معاينة السعر
    previewTitle: 'معاينة السعر',
    previewBase: 'السعر الأساسي',
    previewDiscount: 'الخصم',
    previewFinal: 'السعر النهائي',

    // التحقق
    audiencesRequired: 'اختر فئة مستهدفة واحدة على الأقل',
    itemsRequired: 'أضف إضافة واحدة على الأقل إلى الباقة',
    noAddonsAvailable: 'لا توجد إضافات قابلة للتجميع. أنشئ إضافات بأسعار محددة أولاً.',

    // الأزرار / التنبيهات
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    createError: 'تعذّر إنشاء الباقة',
    updateError: 'تعذّر تحديث الباقة',
    deleteError: 'تعذّر حذف الباقة',
    slugExistsError: 'توجد باقة بهذا المعرّف بالفعل.',
    quoteAddonError: 'لا يمكن إضافة إضافة معتمدة على عرض السعر إلى الباقة.',
  },

  // تضمين الخطة (الخطة المخصّصة) — يُستخدم في صفحة إدارة الخطط
  plan: {
    isCustom: 'خطة مخصّصة',
    isCustomHint: 'عرض مخصّص - يجمع إضافات وخصماً إضافياً.',
    discount: 'الخصم',
    discountValue: 'قيمة الخصم',
    embeddedAddons: 'الإضافات المضمّنة',
    embeddedAddonsHint: 'تُمنح هذه الإضافات للمستخدم عند اشتراكه.',
  },
  // سطر «يشمل الصفقات الخاصة» في BundleCard: كان يظهر بالإنجليزية.
  specialDealsIncluded: 'الوصول إلى الصفقات الخاصة بالمشتركين',
};

export default bundles;
